module.exports = __webpack_public_path__ + "static/img/success-unscreen (2).f6e7dd4f.gif";